import { useState } from 'react';
import { useUpdateCatalog } from '../../../../../../../services/modules/catalogs/catalogs.mutations';
import { useGetCatalog } from '../../../../../../../services/modules/catalogs/catalogs.queries';
import {
  CatalogBannerListState,
  CatalogCreationBannerFieldName,
} from '../../../../../creation/catalogCreationForm.types';
import { UpdateCatalogParams } from '../../../../../repositories/types/catalogs.repository.types';
import { CatalogBannerFieldStates } from '../catalogBannersModal.types';

interface UseCatalogBannersModalParams {
  catalogId: string;
  onClose: () => void;
}

const buildPayload = (fieldStates: CatalogBannerFieldStates): UpdateCatalogParams =>
  Object.entries(fieldStates).reduce<UpdateCatalogParams>(
    (payload, [field, state]) => ({ ...payload, [field]: state.urls }),
    {},
  );

const useCatalogBannersModal = ({ catalogId, onClose }: UseCatalogBannersModalParams) => {
  const { data: catalog } = useGetCatalog({ id: catalogId });
  const { isPending, mutate } = useUpdateCatalog({ catalogId });

  const [fieldStates, setFieldStates] = useState<CatalogBannerFieldStates>({});

  const changedStates = Object.values(fieldStates);

  const handleFieldChange = (
    field: CatalogCreationBannerFieldName,
    state: CatalogBannerListState,
  ) => setFieldStates((previousStates) => ({ ...previousStates, [field]: state }));

  return {
    isSaving: isPending,
    isSaveDisabled:
      isPending || changedStates.length === 0 || changedStates.some((state) => state.isUploading),
    getSavedUrls: (field: CatalogCreationBannerFieldName) => catalog?.[field] ?? [],
    handleFieldChange,
    reset: () => setFieldStates({}),
    submit: () => mutate(buildPayload(fieldStates), { onSuccess: onClose }),
  };
};

export default useCatalogBannersModal;
